











































import Vue from 'vue';
import { Type, Expression, ChainExpression, NoExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<ChainExpression>().extend({
  name: 'BodyEditor',
  computed: {
    noop(): Expression {
      return NoExpression.instance;
    },
    editable(): boolean {
      return !this.readOnly;
    },
  },
  methods: {
    addExpression(expr: Expression) {
      this.value.chain.push(expr);
    },
    updateExpression(index: number, expr?: Expression) {
      if (expr) {
        this.$set(this.value.chain, index, expr);
      } else {
        this.value.chain.splice(index, 1);
      }

      const n = this.value.chain.length;

      if (n === 1) {
        this.input(this.value.chain[0]);
      } else if (n === 0) {
        this.remove();
      } else {
        this.update();
      }
    },
    getRequiredType(index: number): Type | null {
      return index === this.value.chain.length - 1
        ? this.requiredType
        : null;
    },
  },
});
